import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { Row, Col, Button } from 'reactstrap';
import renderRadioButtonsForField from './helpers/renderRadioButtonsForField';

const validate = (values) => {
  const errors = {};
  if (!values.diet) {
    errors.diet = 'Please answer the question';
  }
  return errors;
};

class SignUpDietForm extends Component {
  render() {
    const { initialValues, onSubmit, showSubmissionError } = this.props;
    const dietButtons = [
      {
        title: 'Yes',
        value: 'true',
      },
      {
        title: 'No',
        value: 'false',
      },
    ];
    return (
      <div>
        <Form
          onSubmit={(values) => {
            const errors = validate(values);
            if (Object.keys(errors).length === 0) {
              onSubmit(values);
            } else {
              showSubmissionError(errors);
            }
          }}
          initialValues={initialValues}
          keepDirtyOnReinitialize
          render={({ handleSubmit, form, values }) => (
            <form onSubmit={handleSubmit} className="inline-form">
              <Row>
                <Col className="d-flex">
                  <Field
                    name="diet"
                    id="diet"
                    component={renderRadioButtonsForField}
                    options={dietButtons}
                    optionstype="button"
                    {...{
                      itemProps: {},
                      inputProps: {},
                    }}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col className="d-flex">
                  <Button color="primary" size="lg" type="submit" block>
                    Next
                  </Button>
                </Col>
              </Row>
            </form>
          )}
        />
      </div>
    );
  }
}

SignUpDietForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object),
  showSubmissionError: PropTypes.func,
};

export default SignUpDietForm;
